
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="container max-w-6xl mx-auto px-4 py-4 text-center text-gray-500 text-xs">
      <div className="flex justify-center space-x-4">
        <a 
          href="https://www.mybellehealth.com/terms-of-use/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="hover:text-primary transition-colors"
        >
          Terms of Use
        </a>
        <span className="text-gray-300">|</span>
        <a 
          href="https://www.mybellehealth.com/privacy-policy/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="hover:text-primary transition-colors"
        >
          Privacy Policy
        </a>
        <span className="text-gray-300">|</span>
        <a 
          href="https://www.mybellehealth.com/medical-disclaimer/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="hover:text-primary transition-colors"
        >
          Medical Disclaimer
        </a>
      </div>
    </footer>
  );
};
